import { Button } from '@mui/material';
import styled from 'styled-components';
import { carInfoModalAtom, selectedCenterAtom, selectedPlanCarListAtom } from '@/commons/constants';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { PlanCar } from '@/types/plan';
import { useEffect, useState } from 'react';
import { planCarListAtom } from '@/interfaces/plan/manage';
import { DataGrid, GridColDef, GridRenderCellParams, useGridApiRef, gridPaginatedVisibleSortedGridRowIdsSelector } from '@mui/x-data-grid';
import * as _ from 'lodash';
import { ClearIcon } from '@mui/x-date-pickers/icons';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CarInfo from './CarInfo';
import { CustomCard } from '../../common/CustomMui';

export default function CarList() {
  return <MainContent />;
}

const MainContentWrap = styled.div`
  width: 100%;
  height: 100%;
  flex-grow:1;
  display:flex;
  flex-direction: column;
  .body{
    padding:0;
    width: 100%;
    flex-grow:1
  }
`;

const FilterArea = styled.div`
  width: 100%;
  display:flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding-bottom: 0.5rem;
`;

const MainContent = () => {
  const { data: carList } = useAtomValue(planCarListAtom);

  const [selectedPlanCarList, setSelectedPlanCarList] = useAtom(selectedPlanCarListAtom);
  const selectedCenter = useAtomValue(selectedCenterAtom);

  const setCarInfoModal = useSetAtom(carInfoModalAtom);

  const [contents, setContents] = useState<any[]>();

  const [checkedList, setCheckedList] = useState<PlanCar[]>([]);
  const [modifyList, setModifyList] = useState<PlanCar[]>([]);
  const [modalInfo, setModalInfo] = useState<PlanCar>();

  const column: GridColDef[] = [
    { field: 'center_name', headerName: '센터', width: 100, headerAlign: 'center', align: 'center' },
    { field: 'name', headerName: '차량명', flex: 1, headerAlign: 'center' },
    { field: 'region', headerName: '권역', width: 100, headerAlign: 'center', align: 'center' },
    { field: 'v_work_time', headerName: '운행시간', width: 110, headerAlign: 'center', align: 'center' },
    {
      field: 'lunch_time',
      headerName: '점심시간',
      width: 70,
      headerAlign: 'center',
      align: 'center',
      renderCell: (param?: GridRenderCellParams<any, string[]>) => {
        return (
          <div
            style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            {param.value === null || param.value[0] === param.value[1] ? (
              <ClearIcon htmlColor="#d77" />
            ) : (
              <DoneAllIcon htmlColor="#7a7" />
            )}
          </div>
        );
      },
    },
    {
      field: 'start_type',
      headerName: '출발지',
      width: 80,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: (value?: number) => {
        switch (value) {
          case 1:
            return '차고';
          case 0:
          default:
            return '센터';
        }
      },
    },
    {
      field: 'end_type',
      headerName: '종착지',
      width: 80,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: (value?: number) => {
        switch (value) {
          case 0:
            return '센터';
          case 1:
            return '마지막 배송지';
          case 2:
            return '차고';
          default:
            return '-';
        }
      },
    },
    { field: 'v_dest', headerName: '착지수', width: 90, headerAlign: 'center', align: 'center' },
    { field: 'v_volume', headerName: '체적(L)', width: 90, headerAlign: 'center', align: 'center' },
  ];

  useEffect(() => {
    if (selectedCenter > -1) {
      if (carList && carList.length > 0) {
        const filterdCarList = _.filter(carList, ['center_seq', selectedCenter]);
        const temp = _.sortBy(filterdCarList, 'name').map((item: PlanCar) => {
          return {
            ...item,
            id: item.seq,
            lunch_time: (item.lunch_time || []).map((t: string | null) => t ?? '00:00'),
            v_work_time: item.start_time + ' ~ ' + item.end_time,
            v_dest: (item.min_dest ?? '-') + ' ~ ' + (item.max_dest ?? '-'),
            v_volume: (item.min_volume ?? '-') + ' ~ ' + (item.max_volume ?? '-'),
          };
        });
        setContents(temp);
      }
    } else {
      setContents([]);
    }
  }, [selectedCenter, carList]);

  useEffect(() => {
    if (modifyList.length > 0 && modalInfo && modifyList[0] !== modalInfo) {
      const temp = _.map(contents, (item) => {
        const target = _.find(modifyList, ['id', item.id]);
        if (target) {
          return {
            ...target,
            region: modalInfo.region,
            start_time: modalInfo.start_time,
            end_time: modalInfo.end_time,
            start_type: Number(modalInfo.start_type),
            end_type: Number(modalInfo.end_type),
            min_volume: modalInfo.min_volume,
            max_volume: modalInfo.max_volume,
            min_dest: modalInfo.min_dest,
            max_dest: modalInfo.max_dest,
            lunch_time: (modalInfo.lunch_time || []).map((t: string | null) => t ?? '00:00'),
            v_work_time: modalInfo.start_time + ' ~ ' + modalInfo.end_time,
            v_dest: (modalInfo.min_dest ?? '-') + ' ~ ' + (modalInfo.max_dest ?? '-'),
            v_volume: (modalInfo.min_volume ?? '-') + ' ~ ' + (modalInfo.max_volume ?? '-'),
          };
        } else {
          return item;
        }
      });
      setContents(temp);
      if (selectedPlanCarList && selectedPlanCarList.length > 0) {
        const selectedTemp = _.intersectionBy(temp, selectedPlanCarList, 'id');
        setSelectedPlanCarList(selectedTemp);
      }
    }
  }, [modalInfo]);

  const apiRef = useGridApiRef();

  const handleSelectionModelChange = (val: any) => {
    const temp = val.map((item: number) => {
      return { id: item };
    });
    const target = _.intersectionBy(contents, temp, 'id');
    setCheckedList(target);
    setSelectedPlanCarList(target);
  };

  const handleSelectPageClick = () => {
    const pageIds = gridPaginatedVisibleSortedGridRowIdsSelector(apiRef);
    const current = new Set(apiRef.current.getSelectedRows().keys());
    const allSelected = pageIds.every((id) => current.has(id));
    if (allSelected) {
      pageIds.forEach((id) => current.delete(id));
    } else {
      pageIds.forEach((id) => current.add(id));
    }
    apiRef.current.setRowSelectionModel([...current]);
  };

  const handleSelectAllClick = () => {
    const allIds = (contents ?? []).map((row) => row.id);
    const current = apiRef.current.getSelectedRows();
    if (current.size === allIds.length) {
      apiRef.current.setRowSelectionModel([]);
    } else {
      apiRef.current.setRowSelectionModel(allIds);
    }
  };

  const handleSelectModifyClick = () => {
    if (checkedList.length === 0) return;
    setModifyList(checkedList);
    const target = {
      ...checkedList[0],
      name: checkedList.length + '대',
      cargo: _.find(checkedList, (v) => v.cargo_seq === null) ? true : false,
    };
    setModalInfo(target);
    setCarInfoModal(true);
  };
  const handleRowClick = (item: PlanCar) => {
    setModifyList([item]);
    setModalInfo({ ...item, cargo: item.cargo_seq === null ? true : false });
    setCarInfoModal(true);
  };

  return (
    <CustomCard title={'차량'}>
      <>
        <MainContentWrap>
          <FilterArea>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button size="small" variant="outlined" sx={{ whiteSpace: 'nowrap' }} onClick={handleSelectPageClick}>
                현재 페이지 선택
              </Button>
              <Button size="small" variant="outlined" sx={{ whiteSpace: 'nowrap' }} onClick={handleSelectAllClick}>
                전체 선택
              </Button>
            </div>
            <Button
              disabled={checkedList.length === 0}
              size="small"
              variant="contained"
              color="info"
              onClick={handleSelectModifyClick}
            >
              선택수정
            </Button>
          </FilterArea>
          <div className="body">
            <DataGrid
              apiRef={apiRef}
              checkboxSelection
              keepNonExistentRowsSelected
              disableColumnResize
              disableRowSelectionOnClick
              columns={column}
              onRowClick={(e) => handleRowClick(e.row)}
              rows={contents ?? []}
              onRowSelectionModelChange={(val) => handleSelectionModelChange(val)}
              sx={{ '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root': { display: 'none' } }}
            />
          </div>
        </MainContentWrap>
        <CarInfo target={modalInfo} setInfo={setModalInfo} />
      </>
    </CustomCard>
  );
};
